export const GET_LOCATIONS_COMPREHENSIVE_REQUEST = 'GET_LOCATIONS_COMPREHENSIVE_REQUEST';
export const GET_LOCATIONS_COMPREHENSIVE_SUCCESS = 'GET_LOCATIONS_COMPREHENSIVE_SUCCESS';
export const GET_LOCATIONS_COMPREHENSIVE_FAILURE = 'GET_LOCATIONS_COMPREHENSIVE_FAILURE';
export const RESET_LOCATIONS_COMPREHENSIVE_MESSAGE = "RESET_LOCATIONS_COMPREHENSIVE_MESSAGE";
